
import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";
import Page404 from "../../../components/Page404/Page403";
import BrandConfigurationReport from "../../../components/DataCollection/BrandConfigurationReport/BrandConfigurationReport";

const BrandConfigurationReportScreen = () => {
  let react_env = import.meta.env.VITE_ENV;
  const userData = useSelector(selectUserData);
  const hasBrandConfigurationsReportPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "brands",
    "view_brand_configurations"
  );
  return (
    <>
      {hasBrandConfigurationsReportPermission && react_env === "staging" ?  (
        <BrandConfigurationReport />
      ) : ( 
        <Page404 />
      )}
    </>
  );
};

export default BrandConfigurationReportScreen;
